import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import authService from '../../services/auth/auth.service';



function SideNav() {

  let location = useLocation();

  let locationkey = location.pathname.replaceAll('/', '')

  if (locationkey.indexOf("contractorscard")>=0){
    locationkey = "contractorscard"
  }
  const LOCAL_STORAGE_SEARCH = authService.getCurrentUser()?.shrt + '_crm-' + locationkey + '-search'

  const LOCAL_STORAGE_CONTRACTOR_MENU_CLASS = authService.getCurrentUser()?.shrt + '_crm-'  + 'contractor_menu_class'
  const LOCAL_STORAGE_NOTE_MENU_CLASS = authService.getCurrentUser()?.shrt + '_crm-'  + 'note_menu_class'
  const LOCAL_STORAGE_CONFIG_MENU_CLASS = authService.getCurrentUser()?.shrt + '_crm-'  + 'config_notes_class'

  const LOCAL_STORAGE_PLANNER_MENU_CLASS = authService.getCurrentUser()?.shrt + '_crm-'  + 'planner_menu_class'
   const LOCAL_STORAGE_PANEL_ADMIN_MENU_CLASS = authService.getCurrentUser()?.shrt + '_crm-'  + 'panel_admin_menu_class'
   const LOCAL_STORAGE_CONTACTS_MENU_CLASS = authService.getCurrentUser()?.shrt + '_crm-'  + 'contacts_menu_class'
  const LOCAL_STORAGE_MAIL_MENU_CLASS = authService.getCurrentUser()?.shrt + '_crm-'  + 'mail_menu_class'

   
  const LOCAL_STORAGE_ACTIVE_MENU_CLASS = authService.getCurrentUser()?.shrt + '_crm-'  + 'active_menu_class'

  const [searchQuery, setsearchQuery] = useState("");


  useEffect(()=>{
    // your job here
    if ( localStorage[LOCAL_STORAGE_SEARCH]){
        setsearchQuery(localStorage[LOCAL_STORAGE_SEARCH])  
    }

    if (localStorage[LOCAL_STORAGE_CONTRACTOR_MENU_CLASS]){
      $('#contractorsMenu').addClass('menu-open')
    }

    if (localStorage[LOCAL_STORAGE_NOTE_MENU_CLASS]){
      $('#notesMenu').addClass('menu-open')
    }




    if (localStorage[LOCAL_STORAGE_CONFIG_MENU_CLASS]){
      $('#configurationMenu').addClass('menu-open')
    }

    if (localStorage[LOCAL_STORAGE_PLANNER_MENU_CLASS]){
      $('#plannerMenu').addClass('menu-open')
    }

    if (localStorage[LOCAL_STORAGE_PANEL_ADMIN_MENU_CLASS]){
      $('#adminPanelMenu').addClass('menu-open')
    }

    if (localStorage[LOCAL_STORAGE_CONTACTS_MENU_CLASS]){
      $('#contactsMenu').addClass('menu-open')
    }

    if (localStorage[LOCAL_STORAGE_MAIL_MENU_CLASS]){
      $('#mailMenu').addClass('menu-open')
    }
    

    var curr_url : string = window.location.href
    var origin_url : string = window.location.origin.toString()

    console.log(curr_url.charAt(curr_url.length-1)) 
    if (curr_url.charAt(curr_url.length-1)=='/'){
      //console.log('AAAA')
      curr_url = curr_url.substring(0,curr_url.length-1)
    }
    //console.log(curr_url)
    //console.log(origin_url)

    if (curr_url == origin_url){
      localStorage.removeItem(LOCAL_STORAGE_ACTIVE_MENU_CLASS)
    }else if (localStorage[LOCAL_STORAGE_ACTIVE_MENU_CLASS]){
      var tmp: string='#'+localStorage[LOCAL_STORAGE_ACTIVE_MENU_CLASS]
      //console.log(tmp)
      $(tmp).addClass('active')
    }



  }, []) 
  
  const handleKeyDown = (e : React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      var val : string = $('#input-search-query').val() as string;
      
      if (val === ''){
        localStorage.removeItem(LOCAL_STORAGE_SEARCH)
      }else{
        localStorage.setItem(LOCAL_STORAGE_SEARCH, val)
      }
      window.dispatchEvent(new Event('storage'))
    }
  };
    
  const handleChangeSearch = (event: React.ChangeEvent<HTMLInputElement>): void => {
    
    setsearchQuery(event.target.value)
  };
  
  const handleContractorsFilterAdd = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.nativeEvent.stopImmediatePropagation();;
    //alert('AA');
    return false;
  };

  const handleClearSearch = (event: React.MouseEvent<HTMLElement>) => {
    $('#input-search-query').val('')
    setsearchQuery('')
    localStorage.removeItem(LOCAL_STORAGE_SEARCH)
    window.dispatchEvent(new Event('storage'))
  }

  


  var user_count = 15
  const toggleContractors = (event: any) => {
    event.preventDefault();
   // console.log(navigator.userAgent)
   // console.log(navigator.userAgent.indexOf('Edg'))
   // if (navigator.userAgent.indexOf('Edg') > -1) {
    if ($('#contractorsMenu').hasClass('menu-open')){
      $('#contractorsMenu').removeClass('menu-open')
      localStorage.removeItem(LOCAL_STORAGE_CONTRACTOR_MENU_CLASS)
    }else{
      $('#contractorsMenu').addClass('menu-open')
      localStorage.setItem(LOCAL_STORAGE_CONTRACTOR_MENU_CLASS, 'menu-open')
    }
  //}
    
  }

  const toggleActiveMenu = (event: any) => {
    event.preventDefault();
    console.log($(event.currentTarget).attr('href'))
    //alert(event.target.id)
   //var tmp :string =  $(event.target)[0].id;
    
    $(".mon_menu").each(function() {
      $(this).removeClass('active');
    });
 
    localStorage.setItem(LOCAL_STORAGE_ACTIVE_MENU_CLASS, String($(event.currentTarget).attr('id')))

    //var href = $(event.currentTerget)[0].attr('href')
    //var href = event.terget.getAttribute('href')
    window.location.replace(String($(event.currentTarget).attr('href')));
   // console.log(href)

    //console.log(navigator.appVersion)
    //console.log(navigator.appVersion.indexOf('Edg'))
   // if (navigator.appVersion.indexOf('Edg') > -1) {
   // if ($('#configurationMenu').hasClass('menu-open')){
   //   $('#configurationMenu').removeClass('menu-open')
   //   localStorage.removeItem(LOCAL_STORAGE_CONFIG_MENU_CLASS)
   // }else{
   //   $('#configurationMenu').addClass('menu-open')
   //   localStorage.setItem(LOCAL_STORAGE_CONFIG_MENU_CLASS, 'menu-open')
   // }
 // }
    
  }

  const toggleConfiguration = (event: any) => {
    event.preventDefault();
    //console.log(navigator.appVersion)
    //console.log(navigator.appVersion.indexOf('Edg'))
   // if (navigator.appVersion.indexOf('Edg') > -1) {
    if ($('#configurationMenu').hasClass('menu-open')){
      $('#configurationMenu').removeClass('menu-open')
      localStorage.removeItem(LOCAL_STORAGE_CONFIG_MENU_CLASS)
    }else{
      $('#configurationMenu').addClass('menu-open')
      localStorage.setItem(LOCAL_STORAGE_CONFIG_MENU_CLASS, 'menu-open')
    }
 // }
    
  }

  const togglePlanner = (event: any) => {
    event.preventDefault();
    if ($('#plannerMenu').hasClass('menu-open')){
      $('#plannerMenu').removeClass('menu-open')
      localStorage.removeItem(LOCAL_STORAGE_PLANNER_MENU_CLASS)
    }else{
      $('#plannerMenu').addClass('menu-open')
      localStorage.setItem(LOCAL_STORAGE_PLANNER_MENU_CLASS, 'menu-open')
    }

   
  }


  
  const toggleAdminPanel = (event: any) => {
    event.preventDefault();
    if ($('#adminPanelMenu').hasClass('menu-open')){
      $('#adminPanelMenu').removeClass('menu-open')
      localStorage.removeItem(LOCAL_STORAGE_PANEL_ADMIN_MENU_CLASS)
    }else{
      $('#adminPanelMenu').addClass('menu-open')
      localStorage.setItem(LOCAL_STORAGE_PANEL_ADMIN_MENU_CLASS, 'menu-open')
    }

   
  }

    
  const toggleContactsPanel = (event: any) => {
    event.preventDefault();
    if ($('#contactsMenu').hasClass('menu-open')){
      $('#contactsMenu').removeClass('menu-open')
      localStorage.removeItem(LOCAL_STORAGE_CONTACTS_MENU_CLASS)
    }else{
      $('#contactsMenu').addClass('menu-open')
      localStorage.setItem(LOCAL_STORAGE_CONTACTS_MENU_CLASS, 'menu-open')
    }

   
  }

  const toggleMailPanel = (event: any) => {
    event.preventDefault();
    if ($('#mailMenu').hasClass('menu-open')){
      $('#mailMenu').removeClass('menu-open')
      localStorage.removeItem(LOCAL_STORAGE_MAIL_MENU_CLASS)
    }else{
      $('#mailMenu').addClass('menu-open')
      localStorage.setItem(LOCAL_STORAGE_MAIL_MENU_CLASS, 'menu-open')
    }

   
  }



  const toggleNotes = (event: any) => {
    event.preventDefault();
    //console.log(navigator.appVersion)
    //console.log(navigator.appVersion.indexOf('Edg'))
   // if (navigator.appVersion.indexOf('Edg') > -1) {
    if ($('#notesMenu').hasClass('menu-open')){
      $('#notesMenu').removeClass('menu-open')
      localStorage.removeItem(LOCAL_STORAGE_NOTE_MENU_CLASS)
    }else{
      $('#notesMenu').addClass('menu-open')
      localStorage.setItem(LOCAL_STORAGE_NOTE_MENU_CLASS, 'menu-open')
    }
  //}
    
  }

  return (
    <div>
      {/* Main Sidebar Container */}
      <aside className="main-sidebar sidebar-dark-primary elevation-4">
        {/* Brand Logo */}
        <a href="/" className="brand-link">
          <img src="/dist/img/crmLogo.png" alt="CRM" className="brand-image img-circle elevation-3" style={{opacity: '1'}} />
          <span className="brand-text font-weight-light">Expo Property{/*<img src="dist/img/expopropertyLogo.png" alt="CRM" style={{maxHeight: 30, opacity: '1'}} />*/}</span>
        </a>
        {/* Sidebar */}
        <div className="sidebar">
            {/* Sidebar user panel (optional) */}
            <div className="user-panel mt-3 pb-3 mb-3 d-flex">
              {/* SidebarSearch Form */}
              {/*<div className="form-inline">
                <div className="input-group" data-widget="sidebar-search">
                  <input className="form-control form-control-sidebar" value={searchQuery} id="input-search-query" type="search" onKeyDown={handleKeyDown} onChange={handleChangeSearch} placeholder="Search" title="Search" />
                  <div className="input-group-append">
                    <button id="clearSearchBtn" title="Wyczyść wyszukiwanie" className="btna btn-sidebar" onClick={handleClearSearch}>
                      <i className="fas fa-fw fa-times" />
                    </button>
                  </div>
                </div>
              </div>
              */}
           </div>
         
          
          {/* Sidebar Menu */}
          <nav className="mt-2">
            <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" data-accordion="false">
              {/* Add icons to the links using the .nav-icon class
              with font-awesome or any other icon font library */}
              <li id="plannerMenu" className="nav-item">
                <a href="#"   onClick={togglePlanner} className="nav-link active">
                  <i className="nav-icon fas fa-map" />
                  <p>
                    Planner
                    <i className="right fas fa-angle-left" />
                  </p>
                </a>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <a onClick={toggleActiveMenu} id="plannersMenu" href="/plans" className="mon_menu nav-link">
                      <i className="fas fa-layer-group nav-icon" />
                      <p>Zarządzanie planami</p>
                    </a>
                  </li>
                  
                </ul>

                
              </li>
              <li id="adminPanelMenu" className="nav-item">
                <a href="#"  onClick={toggleAdminPanel} className="nav-link active">
                  <i className="nav-icon fas fa-user-tie" />
                  <p>
                    Panel administratora
                    <i className="right fas fa-angle-left" />
                  </p>
                </a>
                <ul className="nav nav-treeview">
                <li className="nav-item">
                  <a id="usersMenu" onClick={toggleActiveMenu} href="/users" className="mon_menu nav-link">
                    <i className="nav-icon fas fa-users-cog" />
                    <p>
                      Użytkownicy
                      <span className="badge badge-info right">{user_count}</span>
                    </p>
                  </a>
                </li>
                <li className="nav-item">
                  <a id="changesMenu" onClick={toggleActiveMenu} href="/datachanges" className="mon_menu nav-link">
                    <i className="nav-icon fas fa-history" />
                    <p>
                      Historia zmian
                     
                    </p>
                  </a>
                 
                </li>
                <li id="configurationMenu"   className="nav-item">
                  <a href="#" onClick={toggleConfiguration} className="nav-link">
                    <i className="nav-icon fas fa-cogs" />
                    <p>
                      Konfiguracja
                      <i className="right fas fa-angle-left" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a id="labelsMenu" onClick={toggleActiveMenu} href="/fairs" className="mon_menu nav-link">
                        <i className="fas fa-tags nav-icon" />
                        <p>Etykiety</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a id="statesMenu" onClick={toggleActiveMenu} href="/contractorstatedefs" className="mon_menu nav-link">
                        <i className="fas fa-id-card nav-icon" />
                        <p>Statusy</p>
                      </a>
                    </li>
                    <li  className="nav-item">
                      <a id="classificationsMenu" onClick={toggleActiveMenu} href="/classifications" className="mon_menu nav-link">
                        <i className="far fa-object-group nav-icon" />
                        <p>Klasyfikacje</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a id="newmMenu" onClick={toggleActiveMenu} href="/newmstatedefs" className="mon_menu nav-link">
                        <i className="fas fa-id-card nav-icon" />
                        <p>Wysyłka Mailingu</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a id="fairsMenu" onClick={toggleActiveMenu} href="/contractortradedefs" className="mon_menu nav-link">
                        <i className="fas fa-id-card nav-icon" />
                        <p>Branże</p>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
              
           

              

              <li id="contactsMenu" className="nav-item">
                <a href="#"  onClick={toggleContactsPanel} className="nav-link active">
                  <i className="nav-icon fas fa-id-card-alt" />
                  <p>
                    Zarządznie kontaktami
                    <i className="right fas fa-angle-left" />
                  </p>
                </a>
                <ul className="nav nav-treeview">
                <li id="contractorsMenu"  className="nav-item">
                  <a href="#" onClick={toggleContractors}  className="nav-link">
                    <i className="nav-icon far fa-calendar" />
                    <p>
                      Kontrahenci
                      <i className="right fas fa-angle-left" />
                      
                    </p>
                  </a>
                  
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a id="contractorsAllMenu" onClick={toggleActiveMenu} href="/contractors?all=true" className="mon_menu nav-link">
                        <i className="far fa-circle nav-icon" />
                        <span className="badge badge-info right">6</span>
                        <p>Wszyscy</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a id="contractorsTodayMenu" onClick={toggleActiveMenu} href="/contractors?contactdate=today" className="mon_menu nav-link">
                        <i className="fas fa-filter nav-icon" />
                        <p>Z dzisiaj</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a id="contractorsArchiveMenu" onClick={toggleActiveMenu} href="/contractors/archives" className="mon_menu nav-link">
                        <i className="fas fa  fa-archive nav-icon" />
                        <p>Z Archiwum</p>
                      </a>
                    </li>
                  </ul>
                </li>

                <li className="nav-item">
                  <a id="groupsMenu" href="/contractorgroups"  onClick={toggleActiveMenu} className="mon_menu nav-link">
                    <i className="nav-icon fas fa-user-tag" />
                    <p>
                      Grupy
                      
                    </p>
                  </a>
                  
                  
                </li>

                <li className="nav-item">
                  <a id="contactMenu" href="/contacts" onClick={toggleActiveMenu} className="mon_menu nav-link">
                    <i className="fas fa-address-book nav-icon" />
                    <p>Kontakty</p>
                  </a>
                </li>

                <li  id="notesMenu"  className="nav-item">
                  <a  href="#"  onClick={toggleNotes} className="nav-link">
                    <i className="nav-icon fas fa-sticky-note" />
                    <p>
                      Notatki
                      <i className="right fas fa-angle-left" />
                     
                    </p>
                  </a>
                  
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a id="notesAllMenu" onClick={toggleActiveMenu} href="/notes?all=true" className="mon_menu nav-link">
                        <i className="far fa-circle nav-icon" />
                        <span className="badge badge-info right">6</span>
                        <p>Wszystkie</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a id="notesTodayMenu" onClick={toggleActiveMenu} href="/notes?created=today" className="mon_menu nav-link">
                        <i className="fas fa-filter nav-icon" />
                        <span className="badge badge-info right">6</span>
                        <p>Z dzisiaj</p>
                      </a>
                    </li>
                  </ul>
                </li>



                </ul>

              </li>

              <li id="mailMenu" className="nav-item">
                <a href="#" onClick={toggleMailPanel}  className="nav-link active">
                  <i className="nav-icon fas fa-envelope" />
                  <p>
                    Poczta
                    <i className="right fas fa-angle-left" />
                  </p>
                </a>
                <ul className="nav nav-treeview">
                <li className="nav-item">
                    <a id="importedmailMenu" href="/mailbox/importedmails" onClick={toggleActiveMenu} className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Importy</p>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a id="outgoingmailMenu" href="/mailbox/outgoingmail"  onClick={toggleActiveMenu} className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Wychodząca</p>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a href="#" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Przychodząca</p>
                    </a>
                  </li>
                </ul>
            </li>
              
          </ul>
          </nav>
          {/* /.sidebar-menu */}
        </div>
        {/* /.sidebar */}
      </aside>


    </div>
  );
}

export default SideNav;